import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const FILE_FORMAT_RULE_EDITOR_CLASS_NAME = 'FileFormatRuleEditor';
export const FILE_FORMAT_RULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type FileFormatRuleEditorClassSlot =
	(typeof FILE_FORMAT_RULE_EDITOR_CLASS_SLOTS)[number];

export interface FileFormatRuleEditorClasses {
	root: string;
}

export type FileFormatRuleEditorClassKey = keyof FileFormatRuleEditorClasses;

export const getFileFormatRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(FILE_FORMAT_RULE_EDITOR_CLASS_NAME, slot);

export const fileFormatRuleEditorClasses: FileFormatRuleEditorClasses =
	generateUtilityClasses(FILE_FORMAT_RULE_EDITOR_CLASS_NAME, ['root']);

export default fileFormatRuleEditorClasses;
